// extracted by mini-css-extract-plugin
export var errorIcon = "_jo-1";
export var nameLogo = "_jo-0";